import React from 'react';
import {
  Stepper,
  makeStyles,
  StepConnector,
  Step,
  StepLabel,
  withStyles,
  useTheme,
} from '@material-ui/core';
import clsx from 'clsx';
import CircularProgressWithLabel from '../KenCircularProgress/CircularProgressWithLabel';
import DoneIcon from '../../assets/icons/Done.svg';

const useStyles = makeStyles((theme) => ({
  stepper: {
    marginTop: 2,
    padding: '24px 0px 24px 0px',
  },
  root2: {
    padding: 24,
    zIndex: 1,
    position: 'relative',
  },
  root3: {
    boxShadow: `inset 3px 0px 0px ${theme.palette.KenColors.primary}`,
    backgroundColor: theme.palette.KenColors.neutral10,
  },
  labelSteplabel: {
    color: theme.palette.KenColors.neutral400,
    fontSize: '14px !important',
    lineHeight: '20px',
    marginLeft: 16,
    textTransform: 'uppercase',
  },
  activeStepLabel: {
    fontWeight: 'bold !important',
    fontSize: '14px',
    lineHeight: '20px',
    color: `${theme.palette.KenColors.primary} !important`,
  },
  completed: {
    fontSize: '14px',
    lineHeight: '20px',
    color: `${theme.palette.KenColors.neutral400} !important`,
  },
}));

const ColorlibConnector = withStyles((theme) => ({
  root: {
    flex: 0,
    padding: 0,
  },
  active: {
    '& $line': {
      backgroundColor: `${theme.palette.KenColors.tertiaryGreen200}`,
    },
  },
  completed: {
    '& $line': {
      backgroundColor: `${theme.palette.KenColors.tertiaryGreen200}`,
    },
  },
  line: {
    zIndex: 2,
    position: 'absolute',
    marginLeft: '28px',
    marginTop: '-27px',
    width: 4,
    height: 54,
    border: 0,
    backgroundColor: `${theme.palette.KenColors.neutral40}`,
    borderRadius: 1,
  },
}))(StepConnector);

const useColorlibStepIconStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.KenColors.white,
    zIndex: 1,
    color: theme.palette.KenColors.white,
    width: 34,
    height: 34,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    border: `4px solid ${theme.palette.KenColors.neutral40}`,
  },
  active: {
    backgroundColor: theme.palette.KenColors.white,
    border: `4px solid ${theme.palette.KenColors.neutral40}`,
  },
  completed1: {
    border: `4px solid ${theme.palette.KenColors.tertiaryGreen200}`,
    backgroundColor: theme.palette.KenColors.white,
  },
  completed: {
    border: `1px solid ${theme.palette.KenColors.white}`,
    borderRadius: '50%',
    marginTop: 3,
  },
}));

function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed, icon } = props;
  const theme = useTheme();

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed1]: completed,
      })}
    >
      {completed ? (
        <div className={classes.completed}>
          <img
            style={{ border: `1px solid ${theme.palette.KenColors.white}` }}
            src={DoneIcon}
          />
        </div>
      ) : (
        <div
          style={{
            color: active
              ? theme.palette.KenColors.tertiaryGreen200
              : theme.palette.KenColors.neutral40,
          }}
        >
          <CircularProgressWithLabel
            value={50}
            size={35}
            thickness={5}
            label={icon}
            color={theme.palette.KenColors.primary}
          />
        </div>
      )}
    </div>
  );
}

export default function KenFormStepper(props) {
  const classes = useStyles();

  const { activeStep = 0, steps = [] } = props;

  return (
    <div>
      <Stepper
        orientation='vertical'
        className={classes.stepper}
        activeStep={activeStep}
        connector={<ColorlibConnector />}
      >
        {steps.map((step, index) => (
          // <div>
          <Step style={{ textAlign: 'left' }} key={step.stepName}>
            <StepLabel
              className={clsx({
                [classes.root3]: activeStep === index,
              })}
              classes={{
                root: classes.root2,
                label: classes.labelSteplabel,
                active: classes.activeStepLabel,
                completed: classes.completed,
              }}
              StepIconComponent={ColorlibStepIcon}
            >
              {step.stepName}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </div>
  );
}
